var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total"},[_c('div',{staticClass:"tit"},[_vm._v("計"+_vm._s(_vm.qua)+"点")]),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.price))]),_c('div',{staticClass:"yen"},[_vm._v("円")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63532fa0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Total.vue
// module id = null
// module chunks = 